import { compose, lifecycle, withHandlers, withProps } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { pickBy } from 'lodash';
import moment from 'moment-timezone';

import {
  getHasWaitingListEnabled,
  getShopDayEnabled,
  getShopId,
  getShopTimezone,
} from '../shops/selectors';
import { getBarberDayEnabled, getBarberId } from '../barbers/selectors';
import { ANY_BARBER, TIME_WAITING_LIST } from '../constants';
import {
  clearBarberAvailability,
  setActiveDay,
  setActiveTime,
  setActiveTimeBarber,
} from './actions';
import {
  getActiveDayTimes,
  getActiveTime,
  getNextLink,
  getNextUnfetchedDay,
  getNoTimesAvailable,
} from './selectors';
import AvailableTimeRangeProvider from '../hoc/AvailableTimeRangeProvider';
import PickTime from './components/PickTime';
import { fetchShop } from '../shops/actions';
import { fetchBarbers } from '../barbers/actions';
import { fetchSelectedServices } from '../services/actions';
import { getServiceDuration } from '../services/selectors';
import { errorRedirect } from '../actions';
import config from '../../config';
import { generateUrlString, nullFunc } from '../utils/helpers';


const fetchData = compose(
  lifecycle({
    componentDidMount() {
      this.props.clearBarberAvailability();
      this.props.fetchShop()
        .then(this.props.fetchBarbers)
        .then(this.props.fetchService)
        .catch(nullFunc);
    },
  }),
);

const selectedTimeUrlState = compose(
  connect((state, ownProps) => ({
    selectedTime: getActiveTime(state),
    nextLink: getNextLink(state, ownProps.generateUrlString, ownProps.anyBarber),
  }), { setSelectedTime: setActiveTime, setActiveTimeBarber }),
  withHandlers({
    setTime: props => item => () => {
      const reservationTime = moment(item.time).format(config.timeSlugFormat);
      props.setSelectedTime(reservationTime);
      props.setActiveTimeBarber(item.barberRoute || '');
    },
    resetTime: props => () => {
      props.setSelectedTime('');
      props.setActiveTimeBarber('');
    },
  }),
);

const waitingListLink = withProps((props) => {
  const query = pickBy({
    date: props.activeDay,
    anyBarber: props.anyBarber,
  });
  return {
    waitingListLink: {
      pathname: props.generateUrlString({ reservationTime: TIME_WAITING_LIST }),
      query,
    },
  };
});

function mapStateToProps(state, ownProps) {
  const timezone = getShopTimezone(state, ownProps.params.shopRoute);
  const activeDay = state.times.activeDay;
  const dayEnabled =
    ownProps.params.barberRoute === ANY_BARBER
      ? getShopDayEnabled(state, ownProps.params.shopRoute, activeDay)
      : getBarberDayEnabled(state, ownProps.params.barberRoute, activeDay);

  return {
    serviceId: ownProps.params.serviceId,
    servicesFetched: state.services.get('allFetched'),
    serviceDuration: getServiceDuration(state, ownProps.params.serviceId),
    activeDay,
    times: getActiveDayTimes(state, timezone),
    noTimesAvailable: getNoTimesAvailable(state),
    nextUnfetchedDay: getNextUnfetchedDay(state),
    isFetching: state.times.get('isFetching'),
    timezone,
    generateUrlString: params =>
      generateUrlString(
        {
          shopRoute: ownProps.params.shopRoute,
          barberRoute: ownProps.params.barberRoute,
          serviceId: ownProps.params.serviceId,
          ...pickBy(params),
        },
        ownProps.urlPattern,
      ),
    shopId: getShopId(state, ownProps.params.shopRoute),
    barberId: getBarberId(state, ownProps.params.barberRoute),
    shouldShowWaitingList: getHasWaitingListEnabled(state, ownProps.params.shopRoute) && dayEnabled,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return bindActionCreators({
    fetchShop: fetchShop.bind(null, ownProps.params.shopRoute, ownProps.urlPattern),
    fetchBarbers: fetchBarbers.bind(null, ownProps.params.shopRoute, ownProps.urlPattern),
    fetchService: fetchSelectedServices.bind(
      null,
      ownProps.params.shopRoute,
      ownProps.params.barberRoute,
      ownProps.params.serviceId,
      ownProps.params,
      ownProps.urlPattern
    ),
    clearBarberAvailability,
    setActiveDay,
    errorRedirect,
  }, dispatch);
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  fetchData,
  lifecycle({
    componentDidMount() {
      this.props.setActiveDay(moment().format(config.apiDateFormat));
    },
  }),
  AvailableTimeRangeProvider('activeDay'),
  selectedTimeUrlState,
  waitingListLink,
)(PickTime);



// WEBPACK FOOTER //
// ./src/app/times/PickTime.jsx